function getAverageColors(imgEl) {

    var blockSize = 5, 
        blockSize2 = 24, //previously 24
        defaultRGB = {rgb: {r:0, g:0, b:0}, rgb2: {r:0, g:0, b:0} }, // for non-supporting envs
        canvas = document.createElement('canvas'),
        context = canvas.getContext && canvas.getContext('2d'),
        data, width, height,
        i = -4,
        length,
        rgb = {r:0, g:0, b:0},
        rgb2 = {r:0, g:0, b:0},
        count = 0;
        
    if (!context) {
        return defaultRGB;
    }

    height = canvas.height = imgEl.naturalHeight || imgEl.offsetHeight || imgEl.height;
    width = canvas.width = imgEl.naturalWidth || imgEl.offsetWidth || imgEl.width;

    context.drawImage(imgEl, 0, 0);

    try {
        data = context.getImageData(0, 0, width, height);
    } catch(e) {

        console.warn('Error: ', e);
        return defaultRGB;
    }

    length = data.data.length;

    while ( (i += blockSize * 4) < length ) {
        ++count;
        rgb.r += data.data[i];
        rgb.g += data.data[i+1];
        rgb.b += data.data[i+2];
    }

    // ~~ used to floor values
    rgb.r = ~~(rgb.r/count);
    rgb.g = ~~(rgb.g/count);
    rgb.b = ~~(rgb.b/count);

    //reset params for second image run

    count = 0; 
    i=-4; 

    while ( (i += blockSize2 * 4) < length/5 ) {
        ++count;
        rgb2.r += data.data[i];
        rgb2.g += data.data[i+1];
        rgb2.b += data.data[i+2];
    }

    rgb2.r = ~~(rgb2.r/count);
    rgb2.g = ~~(rgb2.g/count);
    rgb2.b = ~~(rgb2.b/count);

    return {rgb, rgb2};

}

export default getAverageColors; 
